module.exports = __webpack_public_path__ + "img/menu_data.be80c128.svg";